




























































import Vue from 'vue'
import UploadDocument from '../../../../../components/UploadDocument/index.vue'
import FileTable from '../../../../../components/FileTable/index.vue'
import {
  ProductionCraftServiceProxy,
  FileUploadDTO,
  SaveFileInfoVO
} from '@/service-proxies/app-v2/product.service-proxies'
import { ProductionPlanServiceProxy, FileInfoDetailDTO,FileDetailInfoVO,  FileUploadDTO as FileUploadDTO2, ResourceFileVO } from '@/service-proxies/app-v2/coproduction.service-proxies'
const productionCraftServiceProxy = new ProductionCraftServiceProxy()
const productionPlanServiceProxy = new ProductionPlanServiceProxy()

export default Vue.extend({
  name: 'DocModal',
  components: { UploadDocument, FileTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    craftList: { // 工艺列表（产品）
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'product' // 使用者区分product、job
    },
    resourId: {  // 资源id（来料计划）
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      checkedList: [], // 勾选的用于上传文件的工艺版本
      indeterminate: true,
      checkAll: false,
      uploadModalVisible: false,
      selectedCraft: '', // 当前工艺版本，用于展示对应文档列表
      jobFileList: []
    }
  },
  computed: {
    resourceId() {
      if (this.mode === 'product' && this.craftList.length && this.selectedCraft) {
        return this.craftList.find(item => item.id === this.selectedCraft).resourceId
      } else if (this.mode === 'job') {
        return this.resourId
      } else {
        return ''
      }
    }
  },
  watch: {
    craftList: {
      handler(val) {
        if (val && val.length) {
          this.selectedCraft = val[0].id
        }
      },
      immediate: true,
      deep: true
    },
    visible(val) {
      if (val) {
        // 打开弹框重置所有项
        this.checkedList = []
        this.selectedCraft = ''
        // console.log(this.craftList)
        if (this.craftList.length) {
          this.checkedList.push(this.craftList[0].id)
          this.selectedCraft = this.craftList[0].id
        }
        this.checkAll = false
        // 如果是job的话去获取所有文件列表
        if (this.mode === 'job') {
          productionPlanServiceProxy.getResourceFile(this.resourceId).then((res: FileDetailInfoVO[]) => {
            this.jobFileList = []
            res.forEach(re => {
              this.jobFileList.push(new FileInfoDetailDTO({
                contentLength: re.contentLength,
                contentType: re.contentType,
                contentMd5: re.contentMd5,
                displayName: re.displayName,
                fileType: re.fileType,
                objectKey: re.objectKey,
                suffix: re.suffix
              }))
            })
          })
        }
      }
    }
  },
  methods: {
    // 勾选checkbox
    onChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.craftList.length
      this.checkAll = checkedList.length === this.craftList.length
    },
    //
    onCheckAllChange(e) {
      const allCheckedArr = this.craftList.map(item => (item.id))
      Object.assign(this, {
        checkedList: e.target.checked ? allCheckedArr : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    // 关闭上传文件的弹框
    closeUploadModal(reload?: boolean) {
      this.uploadModalVisible = false
      if (reload) {

      }
    },
    // 关闭
    close() {
      this.$emit('close')
    },
    // 保存上传的文件至勾选的工艺版本
    handleOk() {
      const fileList = [...this.$refs.uploadFile.fileRecords.documents, ...this.$refs.uploadFile.fileRecords.programs]
      if (this.mode === 'product') {
        if (!this.checkedList.length) {
          this.$message.error(this.$t('page_business_data_save_file_tip'))
          return
        }
        if (!fileList.length) {
          this.$emit('close', true)
          return
        }
        this.loading = true
        let params = new FileUploadDTO({
          craftIds: this.checkedList,
          fileList: []
        })

        fileList.map(file => {
          let character = new SaveFileInfoVO({
            contentLength: file.contentLength,
            contentMd5: file.contentMd5,
            contentType: file.contentType,
            displayName: file.originalFilename,
            fileType: file.fileType,
            objectKey: file.objectKey,
            suffix: file.suffix
          })
          params.fileList.push(character)
        })

        productionCraftServiceProxy.uploadFile(params).then((res: any) => {
          this.$emit('close', true)
        }).finally(() => {
          this.loading = false
        })
      } else {
        if (!fileList.length) {
          this.$emit('close', true)
          return
        }
        this.loading = true
        let params = new FileUploadDTO2({
          resourceId: this.resourceId,
          fileList: this.jobFileList
        })

        fileList.map(file => {
          let existFlag = false
          this.jobFileList.forEach(jobFile => {
            if (jobFile.displayName === file.originalFilename && jobFile.fileType === file.fileType) {
              existFlag = true
              // 直接覆盖
              jobFile = new FileInfoDetailDTO({
                contentLength: file.contentLength,
                contentMd5: file.contentMd5,
                contentType: file.contentType,
                displayName: file.originalFilename,
                fileType: file.fileType,
                objectKey: file.objectKey,
                suffix: file.suffix
              })
            }
          })
          // 非重复项直接添加
          if (!existFlag) {
            let character = new FileInfoDetailDTO({
              contentLength: file.contentLength,
              contentMd5: file.contentMd5,
              contentType: file.contentType,
              displayName: file.originalFilename,
              fileType: file.fileType,
              objectKey: file.objectKey,
              suffix: file.suffix
            })
            params.fileList.push(character)
          }
        })
        productionPlanServiceProxy.upLoadFile(params).then(() => {
          console.log('ff',  params.fileList)
          this.$emit('close', params.fileList)
          this.$message.info(this.$t('page_resource_pool_success'))
          this.loading = false
        })
      }
    }
  }
})
